export default "__VITE_ASSET__75a9f61e__"